export default __webpack_public_path__ + "static/media/instagram-m.b135adaa.svg";